<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img style="max-height: 50px" :src="appLogoImage" alt="logo"/>
        <b-img style="max-height: 50px" :src="appNameImage" alt="logo"/>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{$t("login.welcome")}}! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            {{$t("login.welcomeDesc")}}
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                :label="$t('login.username')"
                label-for="login-username"
              >
                <validation-provider
                  #default="{ errors }"
                  name="username"
                  rules="required"
                >
                  <b-form-input
                    id="login-username"
                    v-model="username"
                    :state="errors.length > 0 ? false:null"
                    name="login-username"
                    placeholder="john"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label >{{ $t('login.password') }}</label>
                  <b-link :to="{name:'auth-forgot-password-v2'}">
                    <small>{{$t('login.forgotPassword')}}?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  {{ $t('login.remember') }}
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                {{ $t('login.submit') }}
              </b-button>
            </b-form>
          </validation-observer>


        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import { mapActions } from 'vuex'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import mixinBase from '@/components/mixin/mixinBase'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility,mixinBase, mixinNotifications],
  data() {
    return {
      status: '',
      password: '',
      username: '',
      sideImg: require('@/assets/images/pages/trade.png'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
    }
  },
  mounted() {
    this.tryConnection();
  },
  setup() {

    // App Name
    const { appName, appNameImage, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
      appNameImage,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/trade1.jpg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    ...mapActions('user', ['login','checkConnection']),
    tryConnection(){
      let $this = this;
      this.checkConnection().then(()=>$this.redirect('/'))
    },
    async validationForm() {
      let $this = this;
      let success = await this.$refs.loginValidation.validate()
      if (!success) {
        return
      }
      this.login({ username: this.username, password: this.password, remember: this.status })
            .then(()=>{
            $this.showSuccessNotification(this.$t('login.loginSuccess'), this.$t('login.loginSuccessDesc'))
            $this.redirect('/')
          })
          .catch(err=> {
            console.log("Login failed",err)
            $this.showErrorNotification($this.$t('login.loginError'), this.getErrorDescription(err))
          })

    },
    redirect(defaultRedirect) {
      let url = new URL(window.location.href);
      let returnUrl = url.searchParams.get("returnUrl");
      if (returnUrl != null && returnUrl !== "") {
        returnUrl = returnUrl.trim();
        //even that vue check for xss attack we made a double check
        //remove all http or other protocols
        returnUrl = returnUrl.replace("http://", "").replace("https://", "").replace("://", "");
        //check for points
        returnUrl = returnUrl.replace(".", "");
        this.$router.push(returnUrl)
      } else
        this.$router.push(defaultRedirect)
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
